import BlockIcon from "@mui/icons-material/Block";
import { useTranslation } from "react-i18next";
import ErrorPage from "../../../../components/ErrorPage/ErrorPage";
import withFullScreen from "../../../../components/hoc/withFullScreen/withFullScreen";

const OrderNotFoundError = () => {
  const { t } = useTranslation("orders");

  return withFullScreen(
    <ErrorPage
      icon={{ Component: BlockIcon, color: "disabled" }}
      showReturnHomeButton
      showBackToHomeLink={false}
      title={t("error.orderNotFound")}
    />
  );
};

export default OrderNotFoundError;
